// FROM
// https://github.com/modusign/modusign-client/blob/b6c3d577fdd8384ea2f73c5ab605ead1afc782d1/app/src/components/AddAttachFileRequestButton/index.tsx

import { Attachment } from '@modusign/react-signing/types';
import cx from 'classnames';

import './AddAttachFileRequestInfo.scss';

interface AddAttachFileRequestInfoProps {
  attachments: Readonly<Attachment[]>;
}

const defaultProps = {
  attachments: [],
};

function AddAttachFileRequestInfo({ attachments }: AddAttachFileRequestInfoProps) {
  if (attachments.length === 0) {
    return null;
  }

  return (
    <button className="AddAttachFileRequestInfo" name="open" type="button">
      {attachments.length > 0 && (
        <div
          className={cx({
            'AddAttachFileRequestInfo__file-list-readonly': true,
          })}
        >
          <div className="AddAttachFileRequestInfo__list-header">
            <div className="AddAttachFileRequestInfo__title">
              <b>첨부파일 요청</b>
            </div>
            <div className="AddAttachFileRequestInfo__attach-file-count">{attachments.length}</div>
          </div>
          <ul className="align-left">
            {attachments.map((attachment) => (
              <li className="AddAttachFileRequestInfo__file-request-list-item" key={attachment.id}>
                {`- ${attachment.title}`}
              </li>
            ))}
          </ul>
        </div>
      )}
    </button>
  );
}

AddAttachFileRequestInfo.defaultProps = defaultProps;

export default AddAttachFileRequestInfo;
